var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8335 5.75V13.4167C26.8335 13.925 27.0354 14.4125 27.3949 14.772C27.7543 15.1314 28.2418 15.3333 28.7502 15.3333H36.4168",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5835 15.3333V9.58333C9.5835 8.56667 9.98736 7.59165 10.7063 6.87276C11.4251 6.15387 12.4002 5.75 13.4168 5.75H26.8335L36.4168 15.3333V36.4167C36.4168 37.4333 36.013 38.4084 35.2941 39.1272C34.5752 39.8461 33.6002 40.25 32.5835 40.25H23.0002",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 32.5833C12.2551 32.5833 13.0028 32.4346 13.7004 32.1457C14.3981 31.8567 15.0319 31.4331 15.5659 30.8992C16.0998 30.3653 16.5233 29.7314 16.8123 29.0338C17.1013 28.3362 17.25 27.5884 17.25 26.8333C17.25 26.0782 17.1013 25.3305 16.8123 24.6329C16.5233 23.9353 16.0998 23.3014 15.5659 22.7675C15.0319 22.2335 14.3981 21.81 13.7004 21.521C13.0028 21.2321 12.2551 21.0833 11.5 21.0833C9.97501 21.0833 8.51247 21.6891 7.43414 22.7675C6.3558 23.8458 5.75 25.3083 5.75 26.8333C5.75 28.3583 6.3558 29.8209 7.43414 30.8992C8.51247 31.9775 9.97501 32.5833 11.5 32.5833V32.5833Z",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 32.5833L5.75 42.1667L11.5 39.2917L17.25 42.1667L14.375 32.5833",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.627bb48da7379ab91cacf0660d25a655.svg";
export { ForwardRef as ReactComponent };